import React from 'react';
import { Link } from 'react-router-dom';
import './Destinations.css';
import TravelTips from './travelTips';
import { useTranslation, Trans } from 'react-i18next';
import useScrollToTop from './ScrollToTop';
import { FiDownload } from 'react-icons/fi';

const destinations = [
  {
    id: 1,
    name: 'Maasai Mara',
    image: '/images/lioness.jpg',
    description: 'Iconic for Big Five safaris.',
    path: '/places/mara',
  },
  {
    id: 2,
    name: 'Lake Naivasha',
    image: '/images/leopard.jpg',
    description: 'From Hippos to Horizons.',
    path: '/places/lnaivasha',
  },
  {
    id: 6,
    name: 'Lake Nakuru',
    image: '/images/bird.jpg',
    description: 'Haven of Pink Skies and Wild Wonders.',
    path: '/places/nakuru',
  },
  {
    id: 3,
    name: 'Amboseli',
    image: '/images/amboseliherd.png',
    description: 'Witness The African Giants.',
    path: '/places/amboseli',
  },
];

const Destinations = () => {
  useScrollToTop();
  const { t } = useTranslation('destinations');

  return (
    <div className="destinations-container">
      <div className="feature-highlight">
        <h2>{t('featureHighlight.title')}</h2>
        <p>{t('featureHighlight.paragraph')}</p>
        <h2>{t('featureHighlight.subtitle')}</h2>
      </div>

      {/* Destination cards */}
      <div className="grid-container">
        {destinations.map((d) => (
          <Link
            key={d.id}
            to={d.path}
            className="destination-card"
            aria-label={`Learn more about ${d.name}`}
          >
            <img src={d.image} alt={d.name} loading="lazy" />
            <div className="destination-overlay">
              <h3>{d.name}</h3>
              <p>{d.description}</p>
            </div>
          </Link>
        ))}
      </div>

      {/* Description block */}
      <div className="description-block">
        <h2>{t('descriptionBlock.title')}</h2>
        <p>
          <Trans i18nKey="descriptionBlock.paragraph1" ns="destinations" />
        </p>
        <p>
          <Trans i18nKey="descriptionBlock.paragraph2" ns="destinations" />
        </p>
        <div className="customize-button-wrapper">
          <Link
            to="/customizesafari"
            className="customize-button"
            aria-label={t('descriptionBlock.button')}
          >
            {t('descriptionBlock.button')}
          </Link>
        </div>
      </div>

      {/* Videos */}
      <div className="video-section">
        <video
          src="/videos/PUNYUA.mp4"
          autoPlay
          loop
          muted
          playsInline
          aria-label="Safari scenes from Kenya"
        />
        <video
          src="/videos/P3.mp4"
          autoPlay
          loop
          muted
          playsInline
          aria-label="Wildlife and nature visuals"
        />
      </div>
      
      {/*8?8 BROCHURE*?/*/}
        <div className="dl-container">
       <a 
        href="/Olenini-safaris.pptx" 
        download="Olenini-Safaris.pptx" 
        className="dl-button"
        style={{ color: 'white' }}
      >
        <FiDownload size={18} />
        Download Brochure
      </a>
      
      </div>


      {/* Travel tips */}
      <section id="travel-tips">
        <TravelTips />
      </section>
    </div>
  );
};

export default Destinations;
